import posthog from 'posthog-js';

// Skip PostHog in the browser outside production so dev activity doesn't pollute analytics
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
   posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://app.posthog.com',
      capture_pageview: false,
      person_profiles: 'identified_only',
   });
}

export default posthog;
